import { render } from "./mythVsFactTwo.vue?vue&type=template&id=52f3b048"
import script from "./mythVsFactTwo.vue?vue&type=script&lang=js"
export * from "./mythVsFactTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__